var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUnderlineIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10.88,
    height: 12.976,
    viewBox: "0 0 10.88 12.976",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_32621",
    "data-name": "Path 32621",
    d: "M9.5-3.5a3.724,3.724,0,0,1-.488,1.92A3.289,3.289,0,0,1,7.624-.3,4.576,4.576,0,0,1,5.536.16H5.328A4.543,4.543,0,0,1,3.256-.288a3.31,3.31,0,0,1-1.384-1.28,3.709,3.709,0,0,1-.5-1.936v-7.472H2.944v7.44a2.084,2.084,0,0,0,.712,1.648,2.655,2.655,0,0,0,1.816.624,2.522,2.522,0,0,0,1.8-.624,2.156,2.156,0,0,0,.664-1.648v-7.44H9.5ZM0,1H10.88V2H0Z",
    transform: "translate(0 10.976)",
    fill: "#081e64"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnderlineIcon);
export default __webpack_public_path__ + "static/media/underline-icon.39eaa5b2ec8f585b957070d9f8d80a5e.svg";
export { ForwardRef as ReactComponent };